module.exports = __webpack_public_path__ + "static/media/cookies.6377de92.jpg";